import React from 'react';
import './Footer.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { forwardTo, forwardToWithParams } from '../../helpers'
import { isWebpSupported } from "react-image-webp/dist/utils";
import { entityActions } from "../../actions";

/* ICONS */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarker, faPhone, faLanguage, faEnvelopeSquare } from '@fortawesome/free-solid-svg-icons'
import { faFacebookSquare, faTwitterSquare, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
/* ICONS */

import { useTranslation } from 'react-i18next';

export const FooterComponent_429 = props => {
    const { isNotFound, entity } = props;

    const { t, i18n } = useTranslation();

    const changeLanguage = lng => {
        i18n.changeLanguage(lng);
        props.dispatch(entityActions.getEntityById({ id: entity.AyuntamientoID, redirect: false }))
    };

    return (
        <div id="footer">
            {!entity && !isNotFound && (
                <div className="container-eu">
                    <div className="txt-eu">
                        <p>{t("footer.financiado")}</p>
                    </div>
                    <Row className="ue-container">
                        <Col
                            sm={12}
                            className="d-flex  "
                        >
                            <img className="ue-log"
                                src={isWebpSupported() ? "https://gecorcloud.com/images/ue.webp" : "https://gecorcloud.com/images/ue.jpg"}
                                alt="ue-logo"
                            />
                        </Col>
                    </Row>
                </div>
            )}
            <footer className='footer-viladecans'
                style={{
                    backgroundImage: `url("${isWebpSupported() ? "https://gecorcloud.com/images/footer2.webp" : "https://gecorcloud.com/images/footer2.jpg"
                        }")`
                }}
            >
                <div className="footer-viladecans">
                    <Container>
                        <Row>
                            <Col sm={4}>
                                <div className="footer-about">
                                    <Row>
                                        <h3 className="footer-informacion-viladecans">{t("footer.viladec-Ayuntamiento")}</h3>
                                    </Row>
                                    <p>{t("footer.co1-1-viladecans")}</p>
                                    <p>{t("footer.co1-2")}</p>
                                    <NavDropdown
                                        title={
                                            <>
                                                <FontAwesomeIcon icon={faLanguage} />
                                                {t("footer.language")}
                                            </>
                                        }
                                        id="collasible-nav-dropdown"
                                    >
                                        <NavDropdown.Item onClick={() => changeLanguage("es")}>
                                            {t("footer.lenguage-es")}
                                        </NavDropdown.Item>
                                        <NavDropdown.Item onClick={() => changeLanguage("en")}>
                                            {t("footer.lenguage-en")}
                                        </NavDropdown.Item>
                                        <NavDropdown.Item onClick={() => changeLanguage("ca")}>
                                            {t("footer.lenguage-ca")}
                                        </NavDropdown.Item>
                                    </NavDropdown>
                                </div>
                            </Col>
                            <Col sm={4}>
                                <div className="footer-contact">
                                    <h3 className="footer-informacion-viladecans"> {t("footer.contact")}</h3>
                                    <p>
                                        <FontAwesomeIcon icon={faMapMarker} />
                                        <a
                                            target="_blank" rel="noopener noreferrer"
                                            href="https://goo.gl/maps/o2ZvvjtdALVMgFMR9"
                                        >
                                            Carrer de Jaume Abril, 2, 08840 Viladecans, Barcelona
                                        </a>
                                    </p>
                                    <p>
                                        <FontAwesomeIcon icon={faPhone} /> 936 35 18 00
                                    </p>

                                    <div className="social-icons">
                                        <a
                                             target="_blank" rel="noopener noreferrer"
                                             href="https://www.viladecans.cat/ca/comentaris-i-consultes-0"
                                        >
                                            <FontAwesomeIcon icon={faEnvelopeSquare} />
                                        </a>
                                        <a
                                            target="_blank" rel="noopener noreferrer"
                                            href="https://www.facebook.com/ajuntamentdeviladecans"
                                        >
                                            <FontAwesomeIcon icon={faFacebookSquare} />
                                        </a>
                                        <a
                                            target="_blank" rel="noopener noreferrer"
                                            href="https://twitter.com/ViladecansTweet"
                                        >
                                            <FontAwesomeIcon icon={faTwitterSquare} />
                                        </a>
                                        <a
                                            target="_blank" rel="noopener noreferrer"
                                            href="https://www.linkedin.com/company/ayuntamientodeviladecans/"
                                        >
                                            <FontAwesomeIcon icon={faLinkedinIn} />
                                        </a>
                                    </div>
                                </div>
                            </Col>
                            <Col sm={4}>
                                <div className="footer-links">
                                    <Row>
                                        <h3 className="footer-informacion-viladecans">{t("footer.co3")}</h3>
                                    </Row>
                                    <Row>
                                        <div className="linkFooter">
                                            <p
                                                className="legal-advice"
                                                //onClick={() => forwardToWithParams("/aviso-legal", {pdf:"https://gecorcloud.com/pdf/AVISO LEGAL.pdf"})}
                                                //onClick={() => forwardToWithParams("/aviso-legal", {pdf:t("footer.Viladecans-pdfAvisoLegal")})}
                                                onClick={() => forwardToWithParams("/aviso-legal", { pdf: "https://gecorcloud.com/pdf/Viladecans/LegalAppViladecansCA.pdf" })}
                                            >
                                                <a
                                                    rel="noopener noreferrer"
                                                    href="#"
                                                    onClick={e => e.preventDefault()}
                                                >
                                                    {t("footer.co3-1")}
                                                </a>
                                            </p>
                                            <p
                                                className="legal-advice"
                                                //onClick={() => forwardToWithParams("/privacy-pdf", {pdf:"https://gecorcloud.com/pdf/politica-de-privacidad.pdf"})}
                                                onClick={() => window.open("https://www.viladecans.cat/es/politica-de-privacidad", "_blank")}
                                            >
                                                <a
                                                    rel="noopener noreferrer"
                                                    href="#"
                                                    onClick={e => e.preventDefault()}
                                                >
                                                    {t("footer.co3-2")}
                                                </a>
                                            </p>
                                            {/*<p
                                                className="contact"
                                                onClick={() => window.open("https://www.viladecans.cat/es/noticies-1", "_blank")}
                                            >
                                                <a
                                                    rel="noopener noreferrer"
                                                    href="#"
                                                    onClick={e => e.preventDefault()}
                                                >
                                                    {t("footer.co3-6")}
                                                </a>
                                    </p>*

                                                <p
                                                className="contact"
                                                onClick={() => forwardTo("/faq-g")}
                                            >
                                                <a
                                                    rel="noopener noreferrer"
                                                    href="#"
                                                    onClick={e => e.preventDefault()}
                                                >
                                                    {t("footer.co3-7")}
                                                </a>
                                            </p>
                                            */}
                                            
                                        </div>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className="copy-ban">
                    <p>{t("footer.copyright", { year: new Date().getFullYear() })}</p>
                </div>
            </footer>
        </div>
    );
};
export default FooterComponent_429;